import { PAGE_TITLES } from "~/configs/pageTitles";
import { usePageTitle } from "~/hooks/usePageTitle";

import styles from "./LinksOverviewPage.module.scss";

const LinksOverviewPage = () => {
  usePageTitle(PAGE_TITLES.linkOverview);

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{PAGE_TITLES.linkOverview}</h1>
    </div>
  );
};
export default LinksOverviewPage;
